

export function isPointIntoRectangle (point, rectangle) {
    return !(
        point.x < rectangle.startX || point.y < rectangle.startY || point.x > rectangle.endX || point.y > rectangle.endY
    );
}